export const phoneDigits = (value = '') => value.replace(/\D/g, '')

/** Con código separado, los números sin + se consideran locales para evitar recortar dígitos válidos. */
export const normalizePhoneValue = (
  value = '',
  countryCode: string | undefined,
  knownCodes: readonly string[],
) => {
  const digits = phoneDigits(value)
  const explicitCode = countryCode === undefined ? undefined : phoneDigits(countryCode)
  const fallbackCode = explicitCode ?? '591'
  if (value.trim().startsWith('+')) {
    const spacedCode = value.trim().match(/^\+(\d{1,3})[\s-]+/)?.[1]
    const code = [
      explicitCode,
      spacedCode,
      ...knownCodes.map(phoneDigits).sort((a, b) => b.length - a.length),
    ].find((candidate) => candidate && digits.startsWith(candidate))
    if (code) return { code: `+${code}`, phoneNumber: digits.slice(code.length) }
    // No inventar un país para un prefijo internacional desconocido.
    return { code: '+', phoneNumber: digits }
  }
  if (explicitCode === undefined && digits.startsWith('591') && digits.length > 8) {
    return { code: '+591', phoneNumber: digits.slice(3) }
  }
  return { code: `+${fallbackCode}`, phoneNumber: digits }
}

/** Normaliza país, número local y teléfono completo; todos contienen solo dígitos. */
export const buildPhoneValue = (countryCode: string, value: string) => {
  const code = phoneDigits(countryCode)
  const phoneNumber = phoneDigits(value)
  return {
    countryCode: code,
    phoneNumber,
    formattedValue: phoneNumber ? `${code}${phoneNumber}` : '',
  }
}
